import { ConversationMessage, MessageType } from '@quromedical/communication';
import { ContentType } from '@quromedical/fhir-common';
import { IMessage, User } from 'react-native-gifted-chat';

import { IMessageProps } from './ChatBubble';

export const userProfile = (sender: string): User => ({
  _id: sender,
  name: 'Not available',
});

type MediaType = 'image' | 'audio' | 'video' | 'contact' | 'documentFile';

const mediaCommunication = (
  conversationMessage: ConversationMessage,
  index: number,
  mediaType: MediaType
): IMessage | undefined => {
  if (conversationMessage.type === MessageType.Media) {
    const { sender, url, createdAt, delivered, read } = conversationMessage;

    const textMessage: IMessage = {
      _id: index,
      text: '',
      [mediaType]: url,
      user: userProfile(sender),
      createdAt: new Date(createdAt),
      received: read,
      sent: delivered,
    };
    return textMessage;
  }
};

const imageCommunication = (
  conversationMessage: ConversationMessage,
  index: number
): IMessage | undefined => mediaCommunication(conversationMessage, index, 'image');

const audioCommunication = (
  conversationMessage: ConversationMessage,
  index: number
): IMessage | undefined => mediaCommunication(conversationMessage, index, 'audio');

const videoCommunication = (
  conversationMessage: ConversationMessage,
  index: number
): IMessage | undefined => mediaCommunication(conversationMessage, index, 'video');

const contactCommunication = (
  conversationMessage: ConversationMessage,
  index: number
): IMessage | undefined => mediaCommunication(conversationMessage, index, 'contact');

const documentFileCommunication = (
  conversationMessage: ConversationMessage,
  index: number
): IMessage | undefined => {
  if (conversationMessage.type === MessageType.Media) {
    const { sender, url, createdAt, delivered, read } = conversationMessage;

    const textMessage: IMessageProps = {
      _id: index,
      text: '',
      documentFile: url,
      contentType: conversationMessage.contentType,
      user: userProfile(sender),
      createdAt: new Date(createdAt),
      received: read,
      sent: delivered,
    };
    return textMessage;
  }
};

export const messageProcessingMap: Record<
  ContentType,
  (conversationMessage: ConversationMessage, index: number) => IMessage | undefined
> = {
  [ContentType.png]: imageCommunication,
  [ContentType.gif]: imageCommunication,
  [ContentType.pdf]: documentFileCommunication,
  [ContentType.doc]: documentFileCommunication,
  [ContentType.odt]: documentFileCommunication,
  [ContentType.xls]: documentFileCommunication,
  [ContentType.csv]: documentFileCommunication,
  [ContentType.dcm]: documentFileCommunication,
  [ContentType.xml]: documentFileCommunication,
  [ContentType.zip]: documentFileCommunication,
  [ContentType.ogg]: audioCommunication,
  [ContentType.mp4]: videoCommunication,
  [ContentType.vcf]: contactCommunication,
  [ContentType.xlsx]: documentFileCommunication,
  [ContentType.docx]: documentFileCommunication,
  [ContentType.json]: documentFileCommunication,
  [ContentType.jpeg]: imageCommunication,
  [ContentType.webp]: imageCommunication,
};
